const REPLACEMENTS = [
	['Add coupons', 'Add coupon'],
	['Cart totals', 'Basket totals'],
]

export const initLabelReplacements = () => {
	const run = () => {
		const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT)
		let node
		while ((node = walker.nextNode())) {
			for (const [from, to] of REPLACEMENTS) {
				if (node.nodeValue.includes(from)) {
					node.nodeValue = node.nodeValue.replaceAll(from, to)
				}
			}
		}
	}

	run()
	let t
	new MutationObserver(() => {
		clearTimeout(t)
		t = setTimeout(run, 75)
	}).observe(document.body, { childList: true, subtree: true })
}
